import { render, staticRenderFns } from "./ChatFlowConfirmPopup.vue?vue&type=template&id=12d6b28a&scoped=true&"
import script from "./ChatFlowConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./ChatFlowConfirmPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChatFlowConfirmPopup.vue?vue&type=style&index=0&id=12d6b28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6b28a",
  null
  
)

export default component.exports